'use client';

import { ChangeEvent, FC } from 'react';

import { Input } from '@/components';

interface SearchBoxProps {
  className?: string;
  placeholder?: string;
  queryHook: (_value: string) => void;
}

const SearchBox: FC<SearchBoxProps> = ({
  queryHook,
  className,
  placeholder,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    queryHook(e.target.value);
  };

  return (
    <Input
      className={className}
      onChange={handleChange}
      placeholder={placeholder}
    />
  );
};

export { SearchBox };
